// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3s2u7","amount":"Amount_amount__21LhK","tip":"Amount_tip__1VBS9","tipHeader":"Amount_tipHeader__2qFVU","tipsWrap":"Amount_tipsWrap__Fnu0X"};